import { HabitEntity } from '../types/data';

// 習慣のデフォルトデータ
export const habitData: HabitEntity[] = [
  {
    id: 'habit-shopping',
    title: '買い物',
    body: 'ストック管理のための買い物習慣',
    created_at: '2025-01-01T00:00:00Z',
    modified_at: '2025-01-01T00:00:00Z',
    is_deleted: false,
    last_done_on: '2025-01-15',
    done_cycle_date: 7, // 週1回
    sort_order: 1000,
  },
  {
    id: 'habit-1',
    title: '朝の散歩',
    body: '健康のために毎朝30分程度の散歩をする',
    created_at: '2025-01-01T00:00:00Z',
    modified_at: '2025-01-01T00:00:00Z',
    is_deleted: false,
    last_done_on: '2025-01-15',
    done_cycle_date: 1, // 毎日
    sort_order: 2000,
  },
  {
    id: 'habit-2',
    title: '読書',
    body: '知識向上のために読書を習慣化する',
    created_at: '2025-01-01T00:00:00Z',
    modified_at: '2025-01-01T00:00:00Z',
    is_deleted: false,
    last_done_on: '2025-01-14',
    done_cycle_date: 1, // 毎日
    sort_order: 3000,
  },
  {
    id: 'habit-3',
    title: '筋トレ',
    body: '週3回の筋力トレーニング',
    created_at: '2025-01-01T00:00:00Z',
    modified_at: '2025-01-01T00:00:00Z',
    is_deleted: false,
    last_done_on: '2025-01-13',
    done_cycle_date: 2, // 2日に1回
    sort_order: 4000,
  },
  {
    id: 'habit-4',
    title: '英語学習',
    body: 'TOEIC対策のための英語学習',
    created_at: '2025-01-01T00:00:00Z',
    modified_at: '2025-01-01T00:00:00Z',
    is_deleted: false,
    last_done_on: '2025-01-12',
    done_cycle_date: 1, // 毎日
    sort_order: 5000,
  },
  {
    id: 'habit-5',
    title: '瞑想',
    body: 'マインドフルネス瞑想で心を整える',
    created_at: '2025-01-01T00:00:00Z',
    modified_at: '2025-01-01T00:00:00Z',
    is_deleted: false,
    last_done_on: '2025-01-11',
    done_cycle_date: 1, // 毎日
    sort_order: 6000,
  },
  {
    id: 'habit-6',
    title: '掃除',
    body: '部屋の掃除・整理整頓',
    created_at: '2025-01-01T00:00:00Z',
    modified_at: '2025-01-01T00:00:00Z',
    is_deleted: false,
    last_done_on: '2025-01-10',
    done_cycle_date: 7, // 週1回
    sort_order: 7000,
  }
];

// UI層で使用するHabit型（camelCase）
export interface Habit {
  id: string;
  title: string;
  body?: string;
  createdAt: string;
  modifiedAt: string;
  deleted: boolean;
  lastDoneOn?: string; // YYYY-MM-DD format
  doneCycleDate?: number; // 実行サイクル日数
  sortOrder?: number; // 表示順（1000刻み）
}
